// Utils: dateUtils
// Purpose: Small helpers for date formatting with guardrails around invalid
// inputs. Keep output stable and localized to en-US long form.
/**
 * Format a date into a readable string
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date)) {
    return 'Invalid date';
  }
  
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric'
  };
  
  return date.toLocaleDateString('en-US', options);
}; 